import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues: IPlanInfo = {
  lineName: '',
  lineId: '',
  sublineName: '',
  sublineID: '',
  planName: '',
  externalCode: '',
  arabicName: '',
  abbreviation: '',
  effectiveFrom: '',
  effectiveTo: '',
  planStatus: '',
};

export const getInputs = (
  values: IPlanInfo = initialValues,
  lovs: Record<string, Record<string, string>>,
  isLineNameDisabled: boolean,
  isSublineNameDisabled: boolean
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      lineName: {
        name: 'lineName',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(values.lineName) ? values.lineName : '',
        disabled: isLineNameDisabled,
        required: true,
        selectOptions: lovs.line,
      },
      sublineID: {
        name: 'sublineID',
        title: 'Subline',
        placeholder: 'Subline',
        type: FormFieldType.select,
        value: !isEmpty(values.sublineID) ? values.sublineID : [],
        required: true,
        selectOptions: lovs.subline,
        disabled: isSublineNameDisabled,
      },
      planName: {
        name: 'planName',
        title: 'Plan Name',
        placeholder: 'Plan Name',
        type: FormFieldType.text,
        value: values.planName,
        required: true,
      },
      externalCode: {
        name: 'externalCode',
        title: 'External Code',
        placeholder: 'External Code',
        type: FormFieldType.text,
        value: values.externalCode,
        required: true,
      },
      arabicName: {
        name: 'arabicName',
        title: 'Arabic Name',
        placeholder: 'Arabic Name',
        type: FormFieldType.text,
        value: values.arabicName,
        required: true,
      },
      abbreviation: {
        name: 'abbreviation',
        title: 'Abbreviation',
        placeholder: 'Abbreviation',
        type: FormFieldType.text,
        value: values.abbreviation,
        required: true,
      },
      effectiveFrom: {
        name: 'effectiveFrom',
        title: 'Effective From',
        placeholder: 'Effective From',
        type: FormFieldType.date,
        value: values.effectiveFrom,
        required: true,
      },
      effectiveTo: {
        name: 'effectiveTo',
        title: 'Effective To',
        placeholder: 'Effective To',
        type: FormFieldType.date,
        value: values.effectiveTo,
        required: true,
        minDate: new Date(values.effectiveFrom),
      },
      planStatus: {
        name: 'planStatus',
        title: 'Status',
        placeholder: 'Status',
        type: FormFieldType.select,
        value: !isEmpty(values.planStatus) ? values.planStatus : 'INACTIVE',
        selectOptions: {},
        required: true,
        hidden: true,
      },
    },
  },
];
